import { httpRequest, endpoint } from "@cirrus/core/http"

export const office365SettingsGET = async () =>
  await httpRequest.get(endpoint.withRoot("/api/v1/author/integrations/office365/app"))

export const office365SettingsPOST = async (payload) =>
  await httpRequest.post(endpoint.withRoot("/api/v1/author/integrations/office365/app"), payload)

export const office365SettingsDELETE = async () =>
  await httpRequest.delete(endpoint.withRoot("/api/v1/author/integrations/office365/app"))

export const office365FilePOST = async (payload) =>
  await httpRequest.post(
    endpoint.withRoot("/api/v1/author/integrations/office365/templates/upload"),
    payload,
    { headers: { "Content-Type": "multipart/form-data" } },
  )

export const templateFileGET = async (id) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/integrations/office365/templates/${id}/download`),
    {
      responseType: "arraybuffer",
    },
  )
